namespace Matrix.Administration {
    export class LanguageColumns {
        static columnsKey = 'Administration.Language';
    }
}
